import { render, staticRenderFns } from "./NavbarAfterLogin-v3.vue?vue&type=template&id=acfbf9fa&scoped=true&lang=pug"
import script from "./NavbarAfterLogin-v3.vue?vue&type=script&lang=js"
export * from "./NavbarAfterLogin-v3.vue?vue&type=script&lang=js"
import style0 from "./NavbarAfterLogin-v3.vue?vue&type=style&index=0&id=acfbf9fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfbf9fa",
  null
  
)

export default component.exports